﻿package com.mgacreative.hotelru.domain.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class Guest(
    val id: String? = null,
    @SerialName("tenant_id") val tenantId: String,
    @SerialName("first_name") val firstName: String,
    @SerialName("last_name") val lastName: String,
    @SerialName("id_passport_no") val idPassportNo: String? = null,
    val country: String? = null,
    @SerialName("birth_date") val birthDate: String? = null,
    val phone: String? = null,
    val email: String? = null,
    @SerialName("created_at") val createdAt: String? = null
)

